//  icons
import {
  FiLayout,
  FiSettings,
  FiPenTool,
  FiTag,
  FiMail,
  FiMapPin,
  FiPhoneCall
} from "react-icons/fi";
import { BsGithub } from "react-icons/bs"
import { GrLinkedinOption } from "react-icons/gr"
// certicates
import fs from "./assets/img/certificate/fs.png";
import CSS from "./assets/img/certificate/css.png";
import js from "./assets/img/certificate/js.png";
import ps from "./assets/img/certificate/ps.png";
import REACT from "./assets/img/certificate/react.png";
import rs from "./assets/img/certificate/rs.png";
import rd from "./assets/img/certificate/rd.png";


// companies icons
import FreelancerBrandIcon from "./assets/img/brands/freelancer.png";
import UpworkBrandIcon from "./assets/img/brands/upwork.png";
import FiverBrandIcon from "./assets/img/brands/fiverr.png";
import BehanceBrandIcon from "./assets/img/brands/behance.png";
import DribbbleBrandIcon from "./assets/img/brands/dribbble.png";

// projects images
import figma from "./assets/img/skills/figma.png";
import Project3 from "./assets/img/projects/insta.gif";
import task from "./assets/img/projects/task.gif";
import Project4 from "./assets/img/projects/p4.gif";
// import Project5 from "./assets/img/projects/p5.webp";
// import Project6 from "./assets/img/projects/p6.webp";

// skills images
import SkillImg1 from "./assets/img/skills/html5.png";
import SkillImg2 from "./assets/img/skills/css3.png";
import SkillImg3 from "./assets/img/skills/js.png";
// import SkillImg4 from "./assets/img/skills/reactjs.png";
import SkillImg5 from "./assets/img/skills/nextjs.png";
// import SkillImg6 from "./assets/img/skills/nodejs.png";
import SkillImg7 from "./assets/img/skills/git.png";
// import SkillImg8 from "./assets/img/skills/figma.png";
import html from "./assets/img/AllSkills/HTML5.png"
import css from "./assets/img/AllSkills/CSS3.png"
import javscript from "./assets/img/AllSkills/JavaScript.png"
import react from "./assets/img/AllSkills/React.png"
import redux from "./assets/img/AllSkills/Redux.png"
import express from "./assets/img/AllSkills/Express.png"
import node from "./assets/img/AllSkills/NodeJS.png"
import mongo from "./assets/img/AllSkills/MongoDB.png"
import git from "./assets/img/AllSkills/Git.png"
import material from "./assets/img/AllSkills/MaterialUI.png"
import tailwind from "./assets/img/AllSkills/Tailwind.png"
import bootstrap from "./assets/img/AllSkills/Bootstrap.png"
import postman from "./assets/img/AllSkills/Postman.png"
import sass from "./assets/img/AllSkills/sass.png"
import chakra from "./assets/img/AllSkills/chakra-ui.png"
import TypeScript from "./assets/img/AllSkills/typescript.png"


// testimonial images
import TestiImage1 from "./assets/img/testimonials/testimonial-1.webp";
import TestiImage2 from "./assets/img/testimonials/testimonial-2.webp";
import TestiImage3 from "./assets/img/testimonials/testimonial-3.webp";


// certificates
export const certificate = [
  {
    issueDate: "Issued Apr 2023 - No Expiration date",
    credentailID: "",
    InsitituteName: "Masai School",
    name: "Full Stack Web Developer (Full-Time Remote)",
    link: "https://drive.google.com/file/d/1m9M89Tgzqi_D0xStpDDiKv1Tue-g9I98/view",
    desc: `A full stack web developer is a person who can develop both client and server software.`,
    img: fs
  },
  {
    img: REACT,
    issueDate: "Issued Apr 2023 - No Expiration date",
    credentailID: "3b04f7eb224e",
    InsitituteName: "HackerRank",
    name: "React",
    link: "https://www.hackerrank.com/certificates/3b04f7eb224e",
    desc: "React is a free and open-source front-end JavaScript library for building user interfaces based on components. It is maintained by Meta and a community of individual developers and companies. "

  },
  {
    img: rs,
    issueDate: "Issued Apr 2023 - No Expiration date",
    credentailID: "643c287a25bbb953ee386cd1",
    InsitituteName: "Masai School",
    name: "React Native",
    link: "https://drive.google.com/file/d/1UzlysS8uvsInJFrJVIoHCX36iedpYjAf/view",
    desc: "It is used to develop applications for Android, Android TV, iOS, macOS, tvOS, Web, Windows and UWP by enabling developers to use the React framework along with native platform capabilities."

  },
  {
    img: rd,
    issueDate: "Issued Apr 2023 - No Expiration date",
    credentailID: "fccd6434136-0056-409c-b919-254a4597f003",
    InsitituteName: "freeCodeCamp",
    name: "Responsive Web Design",
    link: "https://drive.google.com/file/d/1m9M89Tgzqi_D0xStpDDiKv1Tue-g9I98/view",
    desc: `Responsive web design is about creating web pages that look good on all devices! A responsive web design will automatically adjust for different screen. `

  },
  {
    img: CSS,
    issueDate: "Issued Nov 2022 - No Expiration date",
    credentailID: "41ea6162c0fa",
    InsitituteName: "HackerRank",
    name: "CSS",
    link: "https://www.hackerrank.com/certificates/41ea6162c0fa",
    desc: `CSS is the acronym of “Cascading Style Sheets”.
    CSS is a computer language for laying out and structuring web pages (HTML or XML).`

  },
  {
    img: js,
    issueDate: "Issued Apr 2023 - No Expiration date",
    credentailID: "c51f9343cb85",
    InsitituteName: "HackerRank",
    name: "JavaScript (Intermediate)",
    link: "https://www.hackerrank.com/certificates/c51f9343cb85",
    desc: `JavaScript is a scripting language that enables you to create dynamically updating content, control multimedia, animate images, and pretty much everything else.`

  },
  {
    img: ps,
    issueDate: "Issued Apr 2023 - No Expiration date",
    credentailID: "84baf89d5e11",
    InsitituteName: "HackerRank",
    name: "Problem Solving (Intermediate) ",
    link: "https://www.hackerrank.com/certificates/84baf89d5e11",
    desc: `Problem solving is a step-by-step procedure, which defines a set of instructions to be executed in a certain order to get the desired output.`

  },
]

// navigation
export const navigation = [
  {
    name: "Home",
    href: "home",
  },
  {
    name: "About",
    href: "about",
  },
  {
    name: "Skills",
    href: "skills",
  },
  {
    name: "Projects",
    href: "portfolio",
  },
  {
    name: "Github",
    href: "github",
  },
  {
    name: "Contact",
    href: "contact",
  },
];

// social
export const social = [
  {
    icon: BsGithub,
    href: "https://github.com/monumarquis",
  },
  {
    icon: GrLinkedinOption,
    href: "https://www.linkedin.com/in/monu-yadav-2003m/",
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: "",
  },
  {
    img: UpworkBrandIcon,
    href: "",
  },
  {
    img: FiverBrandIcon,
    href: "",
  },
  {
    img: BehanceBrandIcon,
    href: "",
  },
  {
    img: DribbbleBrandIcon,
    href: "",
  },
];

// projects
export const projectsData = [
  {
    id: "1",
    image: 'https://camo.githubusercontent.com/edbcf3d1d9d7a47fdc4a22ce45509dcb0fd79e51e670866b2ddc07a361fdf97b/68747470733a2f2f737566692e76657263656c2e6170702f7374617469632f6d656469612f67796d70726f6a6563742e66336239306135363935663836633033333732642e676966',
    name: "gym.com",
    category: ": React, Chakra-UI, Redux, NodeJS, Express, MongoDB",
    live: "https://gymbro.vercel.app/",
    source: "https://github.com/suFi7867/gym.com",
    desc: "This was a collaborative project built by team of 5 members in 5 days.My work was to create LandingPage and the Login,Signup, OTP, & also contributed in cart feature  Functionality"
  },
  {
    id: "2",
    image: Project3,
    name: "Instagram | Clone",
    category: ": React, Chakra-UI, Redux, NodeJS, Express, MongoDB, Cloudinary",
    live: "https://heartfelt-cuchufli-ae1d49.netlify.app/",
    source: "https://github.com/monumarquis/Instagram_Clone",
    desc: "This was an Individual Project in which I cloned Instagram with authentication and able to upload and delete post with seperate likes & comment functionality and also follow-unfollow users"
  },
  {
    id: "10",
    image: task,
    name: "Task Planner",
    category: ": React, TypeScript, Chakra-UI, Redux, NodeJS, Express, MongoDB",
    live: "https://task-executioner.netlify.app/",
    source: "https://github.com/monumarquis/Task-Planner",
    desc: "This was an Individual Project in which I made Task Palnner with authentication and able to create and delete sprint with seperate tasks functionality and also have user add & delete functionality"
  },
  {
    id: "3",
    image: 'https://sufi.vercel.app/static/media/stackbox.216e1ead7c8acd95f868.gif',
    name: "Stack Box",
    category: ": React, Styled-Components, NodeJS, Express, web-socket, MongoDB",
    live: "https://stackbox.vercel.app/",
    source: "https://github.com/suFi7867/chat-box",
    desc: "This was a collaborative project built by team of 4 members in 2 days.This is a Chatting Application.In this project we build and deploy a real-time chat application"
  },
  {
    id: "4",
    image: Project4,
    name: "Mailchimp | Clone",
    category: ": React, Chakra-UI, Redux, NodeJS , Express",
    live: "https://mailchimpproject.netlify.app/",
    source: "https://github.com/monumarquis/emailChimp-Clone",
    desc: "This was a collaborative project built by team of 5 members in 5 days.My work was to create Homepage and the Admin Page & Functionality"
  },
  {
    id: "5",
    image: "https://data.bloggif.com/distant/user/store/a/6/d/c/087d5d94a6398301b4d8df29f9dbcd6a.gif",
    name: "Booking | Clone ",
    category: " HTML, CSS, JavaScript, SwiperJS,",
    live: "https://magical-toffee-cdb307.netlify.app/",
    source: "https://github.com/shivshankar0965/dusty-jewel-3645",
    desc: "This was a collaborative project built by team of 5 members in 5 days.My work was to create Homepage and the carrental Page,Navbar & Footer"
  },
  {
    id: "6",
    image: "https://data.bloggif.com/distant/user/store/7/6/d/6/375186206f5e6a71bd4c68391ff36d67.gif",
    name: " Mine - Youtube",
    category: ": React, Chakra-UI",
    live: "https://mine-youtube.vercel.app/",
    source: "https://github.com/monumarquis/mine-youtube",
    desc: "This was an Individual Project. In these website I created  Mini - Youtube with Search Functionality"
  },
  {
    id: "7",
    image: "https://data.bloggif.com/distant/user/store/e/a/f/9/2376d193d1439d7316d3602d06639fae.gif",
    name: "Portfolio",
    category: ": React, Chakra-UI,Tailwind-CSS",
    live: "https://mine-youtube.vercel.app/",
    source: "https://github.com/monumarquis/monumarquis.github.io",
    desc: "This is my new portfolio which I recently made using React, JavaScript, CSS and Chakra UI. This is a private repository to protect the code for its uniqueness."
  },
  {
    id: "8",
    image: "https://data.bloggif.com/distant/user/store/4/2/8/3/b8264c973675d6b9821e1dff04c73824.gif",
    name: "Fabbag  | Clone",
    category: ": React, Chakra-UI, Firebase",
    live: "https://crazy-name-9363.vercel.app/",
    source: "https://github.com/monumarquis/Fabbag-Clone",
    desc: "This was an Individual Project. In these website I created  Homepage, Navbar, Footer, About and  Login/Signup page with authentication. "
  },

];
export const ReactProjects = [
  {
    id: "1",
    image: "https://data.bloggif.com/distant/user/store/e/a/f/9/2376d193d1439d7316d3602d06639fae.gif",
    name: "Portfolio",
    category: ": React, Chakra-UI,Tailwind-CSS",
    live: "https://monu-portfolio.netlify.app/",
    source: "https://github.com/monumarquis/monumarquis.github.io",
    desc: "This is my new portfolio which I recently made using React, JavaScript, CSS and Chakra UI. This is a private repository to protect the code for its uniqueness."
  },
  {
    id: "6",
    image: "https://data.bloggif.com/distant/user/store/7/6/d/6/375186206f5e6a71bd4c68391ff36d67.gif",
    name: " Mine - Youtube",
    category: ": React, Chakra-UI",
    live: "https://mine-youtube.vercel.app/",
    source: "https://github.com/monumarquis/mine-youtube",
    desc: "This was an Individual Project. In these website I created  Mini - Youtube with Search Functionality"
  },
  {
    id: "7",
    image: "https://data.bloggif.com/distant/user/store/4/2/8/3/b8264c973675d6b9821e1dff04c73824.gif",
    name: "Fabbag  | Clone",
    category: ": React, Chakra-UI, Firebase",
    live: "https://crazy-name-9363.vercel.app/",
    source: "https://github.com/monumarquis/Fabbag-Clone",
    desc: "This was an Individual Project. In these website I created  Homepage, Navbar, Footer, About and  Login/Signup page with authentication. "
  },

];
export const MernProjects = [
  {
    id: "1",
    image: 'https://camo.githubusercontent.com/edbcf3d1d9d7a47fdc4a22ce45509dcb0fd79e51e670866b2ddc07a361fdf97b/68747470733a2f2f737566692e76657263656c2e6170702f7374617469632f6d656469612f67796d70726f6a6563742e66336239306135363935663836633033333732642e676966',
    name: "gym.com",
    category: ": React, Chakra-UI, Redux, NodeJS, Express, MongoDB",
    live: "https://gymbro.vercel.app/",
    source: "https://github.com/suFi7867/gym.com",
    desc: "This was a collaborative project built by team of 5 members in 5 days.My work was to create LandingPage and the Login,Signup, OTP, & also contributed in cart feature  Functionality"
  },
  {
    id: "2",
    image: Project3,
    name: "Instagram | Clone",
    category: ": React, Chakra-UI, Redux, NodeJS, Express, MongoDB, Cloudinary",
    live: "https://heartfelt-cuchufli-ae1d49.netlify.app/",
    source: "https://github.com/monumarquis/Instagram_Clone",
    desc: "This was an Individual Project in which I cloned Instagram with authentication and able to upload and delete post with seperate likes & comment functionality and also follow-unfollow users"
  },
  {
    id: "3",
    image: 'https://sufi.vercel.app/static/media/stackbox.216e1ead7c8acd95f868.gif',
    name: "Stack Box",
    category: ": React, Styled-Components, NodeJS, Express, web-socket, MongoDB",
    live: "https://stackbox.vercel.app/",
    source: "https://github.com/suFi7867/chat-box",
    desc: "This was a collaborative project built by team of 4 members in 2 days.This is a Chatting Application.In this project we build and deploy a real-time chat application"
  },

  {
    id: "10",
    image: task,
    name: "Task Planner",
    category: ": React, TypeScript, Chakra-UI, Redux, NodeJS, Express, MongoDB",
    live: "https://task-executioner.netlify.app/",
    source: "https://github.com/monumarquis/Task-Planner",
    desc: "This was an Individual Project in which I made Task Palnner with authentication and able to create and delete sprint with seperate tasks functionality and also have user add & delete functionality"
  },
  {
    id: "4",
    image: Project4,
    name: "Mailchimp | Clone",
    category: ": React, Chakra-UI, Redux, NodeJS , Express, MongoDB",
    live: "https://mailchimpproject.netlify.app/",
    source: "https://github.com/monumarquis/emailChimp-Clone",
    desc: "This was a collaborative project built by team of 5 members in 5 days.My work was to create Homepage and the Admin Page & Functionality"
  },
];

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "UI/UX Design",
  },
  {
    name: "web development",
  },
  {
    name: "branding",
  },
];

// All Skills 
export const AllSkills = [
  {
    image: html,
    skill: "HTML5"
  },
  {
    image: css,
    skill: "CSS3"
  },
  {
    image: javscript,
    skill: "JavaScript"
  },
  {
    image: TypeScript,
    skill: "TypeScript"
  },
  {
    image: react,
    skill: "React"
  },
  {
    image: react,
    skill: "React Native"
  },
  {
    image: chakra,
    skill: "Chakra-UI"
  },
  {
    image: material,
    skill: "Material-UI"
  },
  {
    image: bootstrap,
    skill: "Bootstrap"
  },
  {
    image: figma,
    skill: "Figma"
  },
  {
    image: tailwind,
    skill: "Tailwind"
  },
  {
    image: sass,
    skill: "Sass"
  },
  {
    image: redux,
    skill: "Redux"
  },
  {
    image: SkillImg5,
    skill: "Next.js"
  },
  {
    image: node,
    skill: "NodeJS"
  },
  {
    image: express,
    skill: "Express"
  },
  {
    image: mongo,
    skill: "MongoDB"
  },
  {
    image: postman,
    skill: "Postman"
  },
  {
    image: git,
    skill: "Git"
  },
]

// FrontendSkills
export const FrontendSkills = [
  {
    image: html,
    skill: "HTML5"
  },
  {
    image: css,
    skill: "CSS3"
  },
  {
    image: javscript,
    skill: "JavaScript"
  },
  {
    image: TypeScript,
    skill: "TypeScript"
  },
  {
    image: react,
    skill: "React"
  },
  {
    image: react,
    skill: "React Native"
  },
  {
    image: chakra,
    skill: "Chakra-UI"
  },
  {
    image: material,
    skill: "Material-UI"
  },
  {
    image: bootstrap,
    skill: "Bootstrap"
  },
  {
    image: figma,
    skill: "Figma"
  },
  {
    image: tailwind,
    skill: "Tailwind"
  },
  {
    image: sass,
    skill: "Sass"
  },
  {
    image: redux,
    skill: "Redux"
  },
  {
    image: SkillImg5,
    skill: "Next.js"
  },
]


// Backend Skills
export const BackendSkills = [
  {
    image: node,
    skill: "NodeJS"
  },
  {
    image: TypeScript,
    skill: "TypeScript"
  },
  {
    image: express,
    skill: "Express"
  },
  {
    image: mongo,
    skill: "Mongo DB"
  },
  {
    image: postman,
    skill: "Postman"
  },
  {
    image: git,
    skill: "Git"
  },
]
// services
export const services = [
  {
    icon: <FiLayout />,
    name: "Web Design",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
  {
    icon: <FiSettings />,
    name: "Web Development",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
  {
    icon: <FiPenTool />,
    name: "Branding",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
  {
    icon: <FiTag />,
    name: "SEO",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio perferendis volm quibusdam ullam qui dolore.",
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
  {
    authorImg: TestiImage2,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
  {
    authorImg: TestiImage3,
    authorText:
      "Love the simplicity of the service and the prompt customer support. We can’t imagine working without it.",
    authorName: "Olivia Doe",
    authorPosition: "Head of Design, Google",
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: "Have a question?",
    subtitle: "I am here to help you.",
    description: "Email",
  },
  {
    icon: <FiPhoneCall />,
    title: "Have a nice Talk?",
    subtitle: "I am here to talk  you.",
    description: "Contact me at +91- 9319914715",
  },
  {
    icon: <FiMapPin />,
    title: "Current Location",
    subtitle: "New Delhi,India",
    description: "Serving Clients Worldwide",
  },
];
